import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="mx-auto max-w-[1400px] px-4 pb-4 pt-8 md:px-6 md:pb-10 md:pt-12">
      <div className="relative overflow-hidden rounded-lg bg-foreground-950 px-6 py-14 md:px-12 md:py-20">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20long%20empty%20corridor%20with%20warm%20amber%20wall%20lights%20receding%20into%20darkness%2C%20no%20people%2C%20cinematic%20editorial%20photography%2C%20crimson%20accent%20glow%2C%20moody%20minimal%20atmosphere&width=1600&height=700&seq=cta-submit&orientation=landscape"
          alt="投稿爆料页脚背景，抽象灯光走廊"
          className="absolute inset-0 h-full w-full object-cover object-top opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/80 to-foreground-950/50" />
        <div className="relative z-10 max-w-2xl">
          <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 backdrop-blur">
            <i className="ri-send-plane-fill text-accent-400" />
            瓜友爆料通道已开放
          </span>
          <h2 className="mb-4 font-heading text-2xl font-bold text-background-50 md:text-4xl">
            你手里有料，我们帮你把它讲清楚
          </h2>
          <p className="mb-8 text-sm leading-relaxed text-background-200 md:text-base">
            附上原帖链接、关键截图与时间点，我们会核对来源、补齐双方说法，再整理成一条完整时间线。
            材料越完整，越不容易误伤，也越接近事实本身。
          </p>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-edit-box-line" />
              前往投稿
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:border-accent-500 hover:text-accent-400 cursor-pointer"
            >
              了解内容原则
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}